export default __webpack_public_path__ + "static/media/Apple_Pay_logo.9df3111b.svg";